

export const languageOptions  = [
    { value: 'sinhala', label: 'සිංහල' },
    { value: 'tamil', label: 'தமிழ்' },
    { value: 'english', label: 'English' },
];

export const paperOptions = [
  { value: "first", label: "First Paper" },
  { value: "second", label: "Second Paper" },
  { value: "third", label: "Third Paper" },
  { value: "fourth", label: "Fourth Paper" },
];

export const USER_NAV_LIST = [
    {id: 1, item: "Unregister Users"},
    {id: 2, item: "Pending User"},
    {id: 3, item: "Studants"},
]


export const RESPONSE_STATUS = [
    {label: "Not Answer", value: 1},
    {label: "Joined", value: 2},
    {label: "Not Joined", value: 3}
]





